import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dfb8cd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "ABOUT", -1))
const _hoisted_3 = { class: "copyright" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nbc-logo" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.year === 2023)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "State Key Laboratory of NBC Protection for Civilian Copyright © 2023"))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "State Key Laboratory of NBC Protection for Civilian Copyright © 2023=" + _toDisplayString(_ctx.year), 1))
    ])
  ]))
}